document.addEventListener("DOMContentLoaded", function () {
  document.querySelectorAll(".copy-button").forEach(function (button) {
    button.addEventListener("click", function () {
      const wrapper = button.closest(".code-block-wrapper");
      const codeBlock = wrapper.querySelector(".code-block");

      const text = codeBlock.innerText;

      navigator.clipboard.writeText(text).then(function () {
        button.innerText = "Copied!";
        
        setTimeout(function () {
          button.innerHTML = `
            <svg xmlns="http://www.w3.org/2000/svg"
                 viewBox="0 0 24 24"
                 width="18"
                 height="18"
                 fill="currentColor">
              <path d="M16 1H4a2 2 0 0 0-2 2v12h2V3h12V1zm3 4H8a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h11a2 2 0 0 0 2-2V7a2 2 0 0 0-2-2zm0 16H8V7h11v14z"/>
            </svg>
          `;
        }, 1500);
      });
    });
  });
});
